import { SimpleObjectInterface } from '@thewhite/react-global-module/lib/interfaces';
import { DateService } from '@thewhite/react-global-module/lib/services';
import { DateType } from '@thewhite/react-global-module/lib/types';
import * as t from 'io-ts';
import BASE_PROGRESS_STATUS, { BaseProgressStatusEnumType } from '../../Global/enums/baseProgressStatus';
import { BaseEntity, BaseEntityType } from '../../Global/models/baseEntity';

export const EventListType = t.interface({
    author: BaseEntityType,
    createDate: DateType,
    id: t.string,
    name: t.string,
    main: BaseEntityType,
    object: BaseEntityType,
    status: BaseProgressStatusEnumType,
});

export interface EventListDto extends t.TypeOf<typeof EventListType> {
}

class EventList {
    author: BaseEntity;
    createDate: Date | null;
    id: string;
    name: string;
    main: BaseEntity;
    object: BaseEntity;
    status: SimpleObjectInterface;

    constructor(params: EventListDto) {
        this.author     = new BaseEntity(params.author);
        this.createDate = DateService.getValidDate(params.createDate);
        this.id         = params.id;
        this.name       = params.name;
        this.main       = new BaseEntity(params.main);
        this.object     = new BaseEntity(params.object);
        this.status     = BASE_PROGRESS_STATUS[params.status];
    }
}

export default EventList;
